import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmBtnAccCreation from "../../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import GstDetails from "../../../../../components/_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../../components/_utils/AccountCreationComponents/PanDetails";
import { useGstVerification } from "../../../../../components/verification/hooks/useGstVerification";
import { usePanVerification } from "../../../../../components/verification/hooks/usePanVerification";
import AssociateAccountEdit from "../../../../../containers/Accounts/BeneficiaryEditAccount/AssociateAccountEdit";
import GSTVerification from "../../../../../containers/Settings/GSTDetails";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import LargePopupRedirect from "../../../../_utils/CommonPopups/CommonLargePopupRedirect";
import TaxAccountDetailsPopup from "../../TaxAccountDetailsPopup";
import CommonLayout from "../../../../_utils/CommonLayout";

const TaxAccoountStepPAN = (props) => {
  const {
    handlePanChange,
    payload,
    setPayload,
    verifiedPan,
    verifyPANisLoading,
    lookupNext,
    setLookupNext,
    panDetails,
    focusState,
    beneLookData,
    beneLookLoading,
    setIsArchived,
    setIsApproved,
    setIsDennied,
    setIsPending,
    setAccountType,
    setIsActive,
    isActive,
    setHideBlock,
    setNonArchive,
    setShowAccInfo,
  } = props;

  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [activeTab, setActiveTab] = useState("Active");
  const [slideDirection, setSlideDirection] = useState("right");
  const [taxAccountDetails, setTaxAccountDetails] = useState(false);
  const [taxAccountId, setTaxAccountId] = useState("");

  const panHook = usePanVerification(payload.panNumber);
  const gstHook = useGstVerification(payload.gstin, payload.panNumber);

  const accounts = beneLookData?.beneficiary_accounts || [];
  const hasAccounts = accounts.length > GlobalConfiguration?.lengthCheckZero;

  const isPanVerified =
    !panHook.loading && (panHook.verified === true || verifiedPan === true);

  const haveAcheived = accounts.find((v) => v?.approval_status === "archived");
  const haveApproved = accounts.find((v) => v?.approval_status === "approved");
  const haveDennied = accounts.find((v) => v?.approval_status === "denied");
  const havePending = accounts.find((v) => v?.approval_status === "pending");
  const haveBlock = accounts.find((v) => v?.approval_status === "blocked");
  const haveRejected = accounts.find((v) => v?.approval_status === "rejected");

  const GSTStatus =
    payload.gstin.length === GlobalConfiguration?.lengthCheckZero
      ? null
      : gstHook.GSTStatus;

  const isConfirmDisabled =
    !isPanVerified ||
    (payload.gstin.length > GlobalConfiguration?.lengthCheckZero &&
      !gstHook.gstVerified);

  const showNoAssociated =
    isPanVerified &&
    payload.panNumber?.length === GlobalConfiguration?.panLength &&
    !beneLookLoading &&
    accounts.length === GlobalConfiguration?.lengthCheckZero;

  const handleGSTChange = (e) => {
    let value = e.target.value.toUpperCase();
    value = value.replace(/[^A-Z0-9]/g, "");

    if (value.length > 15) return;
    setPayload((prev) => ({
      ...prev,
      gstin: value,
    }));

    setLookupNext(false);
  };

  const ActiveData = () => {
    setIsActive(false);
    setIsDennied(false);
    setIsApproved(false);
    setIsArchived(false);
    setActiveTab("Active");
    setIsPending(false);
    setNonArchive(false);
    setAccountType({ type: "", id: "" });
    setHideBlock(false);
    setShowAccInfo(false);
  };

  const DeactiveData = () => {
    setIsActive(true);
    setIsDennied(false);
    setIsApproved(false);
    setIsArchived(false);
    setIsPending(false);
    setActiveTab("Inactive");
    setNonArchive(false);
    setShowAccInfo(false);
    setAccountType({ type: "", id: "" });
  };

  useEffect(() => {
    if (gstHook.details?.business_name) {
      setPayload((prev) => ({
        ...prev,
        gst_org_name: gstHook.details.business_name,
      }));
    }
  }, [gstHook.details]);

  useEffect(() => {
    if (payload.panNumber?.length !== GlobalConfiguration?.panLength) {
      setLookupNext(false);
      setPayload((prev) => ({
        ...prev,
        gstin: "",
        gst_org_name: "",
      }));
    }
  }, [payload.panNumber]);

  return (
    <>
      {taxAccountDetails && (
        <>
          <TaxAccountDetailsPopup
            closeBeneAccountDetailModal={() => {
              setTaxAccountDetails(false);
            }}
            tax_account_id={taxAccountId}
            type={"tax_account_detail_modal"}
          />
        </>
      )}
      {showPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: gstHook.details?.gstin_no,
            })
          }
          closeiconhandleFunction={() => setShowPopup(false)}
        >
          <GSTVerification
            gst_number={gstHook.details?.gstin_no}
            popup
          />
        </LargePopupRedirect>
      )}

      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <div className="w-full flex flex-col">
            <PanDetails
              verifiedPan={verifiedPan}
              verifyPANisLoading={verifyPANisLoading}
              panNumber={payload.panNumber}
              handlePanChange={handlePanChange}
              panDetails={panDetails}
            />

            {isPanVerified &&
              payload.panNumber?.length === GlobalConfiguration?.panLength && (
                <GstDetails
                  gstVerified={gstHook.gstVerified}
                  GSTLinked={gstHook.GSTLinked}
                  beneVerifyGST={{
                    status: gstHook.status,
                    gstin_details: gstHook.details,
                    errors: gstHook.error,
                  }}
                  isGSTLoading={gstHook.loading}
                  GstNumber={payload.gstin}
                  setShowPopup={setShowPopup}
                  handleChange={handleGSTChange}
                  focusState={focusState}
                />
              )}
          </div>

          <div className="w-full flex flex-col pb-padding-md Qsmd:pb-padding-base">
            {showNoAssociated && (
              <div className="max-w-[var(--create-box-width)] bg-primary-card rounded-border-radius-md p-padding-md flex flex-col items-center">
                <div className="w-width-full h-height-full">
                  <p className="flex flex-col gap-gap-sm text-text-primary text-base font-semibold">
                    Associated Accounts
                  </p>

                  <div className="text-text-secondary text-xs mt-margin-md">
                    <p className="font-semibold text-sm mb-margin-xs text-text-primary">
                      No associated accounts found
                    </p>
                    <p>
                      There are no existing accounts that are associated with
                      the PAN provided.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {isPanVerified &&
              payload.panNumber?.length === GlobalConfiguration?.panLength &&
              hasAccounts && (
                <>
                  <ConfirmBtnAccCreation
                    type="pan"
                    status={beneLookData?.status}
                    lookupNext={lookupNext}
                    GSTStatus={GSTStatus}
                    isButtonDisabled={isConfirmDisabled}
                    isGSTLoading={verifyPANisLoading || gstHook.loading}
                    handleClick={() => {
                      if (isConfirmDisabled) return;
                      if (
                        payload.gstin?.length ===
                          GlobalConfiguration?.gstLength &&
                        !(gstHook.GSTStatus && gstHook.GSTLinked)
                      )
                        return;

                      setLookupNext(true);
                    }}
                  />

                  <AssociateAccountEdit
                    ActiveData={ActiveData}
                    DeactiveData={DeactiveData}
                    haveAcheived={haveAcheived}
                    haveDennied={haveDennied}
                    haveBlock={haveBlock}
                    haveRejected={haveRejected}
                    haveApproved={haveApproved}
                    havePending={havePending}
                    isApprovedState={accounts}
                    isActive={isActive}
                    activeTab={activeTab}
                    slideDirection={slideDirection}
                    setSlideDirection={setSlideDirection}
                    verifiedPan={isPanVerified}
                    details={false}
                    beneLookLoading={beneLookLoading}
                    addSpacesToNumber={(number) =>
                      number?.replace(/(.{4})/g, "$1 ").trim()
                    }
                    type="taxDetails"
                    setAccountId={setTaxAccountId}
                    setAccoutDetails={setTaxAccountDetails}
                  />
                </>
              )}
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default TaxAccoountStepPAN;
